// extracted by mini-css-extract-plugin
export default {"display":"PhoneDisplay_display__9OVWt","phoneText":"PhoneDisplay_phoneText__YF7Jk","placeholder":"PhoneDisplay_placeholder__JLCfe"};